import { ArrowRight, HandHeart } from "@phosphor-icons/react";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/f12c7e32-58f0-4ea3-8168-eca87b403141/images/35344a3152699cdc9eafeec4a682ea2ac132e4fc9ea1f89db798986c6b01b63b.png";

export default function Hero({ onDonate, onVolunteer }) {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-60 md:pt-72 pb-24 md:pb-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.18] pointer-events-none"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 paper-grain opacity-40 pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-4xl">
          <p className="label-eyebrow mb-6 animate-fade-up" style={{ animationDelay: "0.05s" }}>
            <span className="inline-block w-8 h-px bg-[#5C6B51] align-middle mr-3" />
            Evenings of warmth, dignity & welcome
          </p>

          <h1
            data-testid="hero-headline"
            className="font-headline font-light text-[#1F1A17] tracking-tight text-5xl sm:text-6xl lg:text-[5.5rem] leading-[1.02] animate-fade-up"
            style={{ animationDelay: "0.15s" }}
          >
            Come inside!
            <br />
            <span className="italic text-[#C25934]">A table is set</span> for you.
          </h1>

          <p
            className="mt-8 max-w-2xl text-lg md:text-xl text-[#5A524A] leading-relaxed animate-fade-up"
            style={{ animationDelay: "0.25s" }}
          >
            Hearthside Gathering is an evening community space offering freshly cooked meals,
            hygiene supplies, and the quiet companionship of neighbors who care. No
            paperwork. No questions. Just a warm chair, a hot plate, and people who are glad
            you came.
          </p>

          <div
            className="mt-12 flex flex-wrap items-center gap-4 animate-fade-up"
            style={{ animationDelay: "0.35s" }}
          >
            <button
              data-testid="hero-donate-button"
              onClick={onDonate}
              className="btn-hearth group inline-flex items-center gap-3 rounded-full bg-[#C25934] hover:bg-[#A04728] text-white px-8 py-4 text-base font-semibold"
            >
              <HandHeart size={20} weight="duotone" />
              Make a Donation
              <ArrowRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </button>

            <button
              data-testid="hero-volunteer-button"
              onClick={onVolunteer}
              className="btn-hearth inline-flex items-center gap-3 rounded-full bg-[#5C6B51] hover:bg-[#434E3B] text-white px-8 py-4 text-base font-semibold"
            >
              Become a Volunteer
            </button>

            <span className="font-accent text-2xl text-[#C25934] ml-2 ember-glow">
              our goal is to be available every evening
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
